import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, map } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { handleError } from 'src/app/shared/functions/error-handler';
import { assertTrustedUrl } from 'src/app/shared/functions/validate-url';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { EvaluatorAvailabilityRequest } from 'src/app/shared/interfaces/evaluator-session-avaliablity';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
import {
  MeetingRecordList,
  MeetingRequestModel
} from 'src/app/shared/interfaces/iep-attendes.model';
import {
  ProviderAvailabilityResponseItem,
  ProviderSessionAvailability,
} from 'src/app/shared/interfaces/provider-seession-avaliability';
import { User } from 'src/app/shared/models/user';
import { ScheduleFieldVisibilityConfig } from 'src/assets/config/schedule-field-visibility-config';
import { SystemRecommendedAgency } from '../constants/actions-behalf-of-provider-text';
import {
  AssignToProviderModel,
  getStudentSchoolAddressModel,
} from '../constants/assign-provider-request-model';
import { BundleRequestModel } from '../constants/bundle-request-model';
import { RequestType } from '../constants/mandates-status.constants';
import { IProviderManagementInfo } from '../constants/provider-management-routes';
import { OnBehalfActionType } from '../enums/on-behalf-action-types';
import {
  AssignmentRequest,
  ReAssignmentRequest,
} from '../interfaces/assign-evaluator-submit-model';
import { AssignProviderResponse } from '../interfaces/assign-provider-request';
import { IBundle } from '../interfaces/bundle-model';
import { ICancelMeetingResponse } from '../interfaces/cancel-pa-response';
import { ICompareMandatesPaylaod } from '../interfaces/compare-mandates-payload';
import { contractAgenciesResponse } from '../interfaces/contract-agencies-response';
import { evaluatorDashboardResponse } from '../interfaces/evaluator-dashboard-response';
import { FeeForServiceResponse } from '../interfaces/ffs-model';
import { ISchedulerResponse } from '../interfaces/get-scheduler-response';
import { GlobalFilterForm } from '../interfaces/global-filter-form.model';
import { IMandatesCompareResponse } from '../interfaces/mandates-compare-response';
import { GetMatchingSchedulesResponse } from '../interfaces/matching-schedule';
import { IMatchingDetailsPayload } from '../interfaces/matching-student-payload';
import { IProviderMeetingDetails } from '../interfaces/pa-meeting-details';
import { DashoboardPMRequest } from '../interfaces/pm-dashboard.request';
import { DashboardPMResponse } from '../interfaces/pm-dashboard.response';
import {
  AddPackageResponse, EvaluationAttendeeResponse,
  LocatePrimaryAgencyRequest,
  LocatePrimaryAgencyResponse,
  OBDDetailsRequest,
  OBDDetailsResponse,
  ProviderAgencyResponse,
  RacRequest,
  RsaPackageResponse,
  RsaStatusUpdatePayload,
  SplitMandatesResponse,
  StudentScheduleRequest,
  StudentScheduleResponse,
  StudentSchoolAddressResponse,
  UnbundleRequest
} from '../interfaces/provider-management-service.interfaces';
import { ProviderPanelRequest } from '../interfaces/provider-panel-request';
import { ProviderPanelResponse } from '../interfaces/provider-panel-respone';
import {
  EvaluatorProvider,
  SearchEvaluatorRequest,
  SearchEvaluatorResponse,
} from '../interfaces/provider-search';
import { RejectWithdrawalTx } from '../interfaces/reject-withdrawlTx.model';
import { RSAPackageDto } from '../interfaces/rsa-package';
import { weeklyScheduleResponse } from '../interfaces/weekly-schedule-response';
import { ObdReSubmitModel } from '../models/obd-resubmit.model';
import { OBDSaveModel } from '../models/obd-save-model';
import { retroActionsModel } from '../models/retro-actions.model';
import {
  CancelEvaluatorModel,
  MeetingRequest,
} from '../models/schedule-evaluator-model';
import { ScheduleEventSaveModel } from '../models/schedule-save-model';
import { ScheduleTimeRequestModel } from '../models/schedule-time-request-model';
import { singleAwardToAgencySaveModel } from '../models/single-award-to-agency-save.model';
import { SubmitOBDAgencyResponse } from '../models/submit-obd-agency-response';
import { UpdateMandateScheduleRequest } from '../models/submit-split-mandates.model';
import { UpdateEventsModel } from '../models/update-events-model';
import { GetBundleRequestModel } from '../models/get-bundle.model';
import { RecombinePayload } from '../interfaces/recombine-payload';
import { RelatedContractAgenciesRequest } from '../models/related-contract-agencies-request';

export interface HolidayResponse {
  holidayName: string;
  holidayDate: string | Date;
}

@Injectable({
  providedIn: 'root',
})
export class ProviderManagementService {
  config: IAppConfig;
  private structureInfoSubject: BehaviorSubject<IProviderManagementInfo | null> =
    new BehaviorSubject<IProviderManagementInfo | null>(null);
  info$: Observable<IProviderManagementInfo | null> =
    this.structureInfoSubject.asObservable();
  private returnSchoolSubject: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  returnSchool$: Observable<boolean | null> = this.returnSchoolSubject.asObservable();
  public globalFilterFormValueSubject: BehaviorSubject<GlobalFilterForm> =
    new BehaviorSubject<GlobalFilterForm | null>(null);
  globalFilterForm$: Observable<GlobalFilterForm> =
    this.globalFilterFormValueSubject.asObservable();
  public mandateTypeSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  mandateType$: Observable<string> = this.mandateTypeSubject.asObservable();

  public popupClose$: Subject<boolean> = new Subject<boolean>();
  popupCloseObservable$: Observable<boolean> = this.popupClose$.asObservable();


  public scheduleTimeDetails: Subject<Partial<ScheduleTimeRequestModel>> = new Subject<Partial<ScheduleTimeRequestModel>>();
  scheduleTimeDetails$: Observable<Partial<ScheduleTimeRequestModel>> = this.scheduleTimeDetails.asObservable();

  public bindScheduleDetails: BehaviorSubject<Partial<ScheduleTimeRequestModel> | null> = new BehaviorSubject<Partial<ScheduleTimeRequestModel> | null>(null);
  bindScheduleDetails$: Observable<Partial<ScheduleTimeRequestModel> | null> = this.bindScheduleDetails.asObservable();


  public scheduleErrorMessages = new Subject<ScheduleFieldVisibilityConfig>();
  scheduleErrorMessages$: Observable<ScheduleFieldVisibilityConfig> = this.scheduleErrorMessages.asObservable();

  public bindSelectedScheduleDetails: BehaviorSubject<any> =
    new BehaviorSubject<any>(null);
  bindSelectedScheduleDetails$: Observable<any>
    = this.bindSelectedScheduleDetails.asObservable();


  public isWeekySelected: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  isWeekySelected$: Observable<boolean>
    = this.isWeekySelected.asObservable();

  public selectedAddMandate: BehaviorSubject<DashboardPMResponse[]> =
    new BehaviorSubject<DashboardPMResponse[]>(null);
  selectedAddMandate$: Observable<DashboardPMResponse[]> = this.selectedAddMandate.asObservable();

  private independentProviderSelectedSubject = new BehaviorSubject<boolean>(false);
  public independentProviderSelected$ = this.independentProviderSelectedSubject.asObservable();

  private selectedType = new BehaviorSubject<string>(null);
  public selectedType$ = this.selectedType.asObservable();

  isPreschool: BehaviorSubject<number | null> =
    new BehaviorSubject<number | null>(0);
  isPreschool$: Observable<number | null> =
    this.isPreschool.asObservable();

  uncheckMandates: BehaviorSubject<boolean | null> =
    new BehaviorSubject<boolean | null>(false);
  uncheckMandates$: Observable<boolean | null> =
    this.uncheckMandates.asObservable();
 private selectedOutreachDeadLineDetails = new BehaviorSubject<any>(null);
  public selectedOutreachDeadLineDetails$ = this.selectedOutreachDeadLineDetails.asObservable();

  setDeadLineDetails(selected): void {
    this.selectedOutreachDeadLineDetails.next(selected);
  }
  setIndependentProviderSelected(selected: boolean): void {
    this.independentProviderSelectedSubject.next(selected);
  }

  setIsPreschool(isPreschool: number): void {
    this.isPreschool.next(isPreschool);
  }
  setselectedType(isPreschool: number): void {
    this.isPreschool.next(isPreschool);
  }

  setUnCheckMandates(data: boolean): void {
    this.uncheckMandates.next(data);
  }

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  setSelectedAddMandate(info: any): void {
    this.selectedAddMandate.next(info);
  }

  setIsWeekySelected(info: any): void {
    this.isWeekySelected.next(info);
  }


  setScheduleDetails(info: any): void {
    this.bindSelectedScheduleDetails.next(info);
  }

  setBindScheduleDetails(info: any): void {
    this.bindScheduleDetails.next(info);
  }
  setScheduleTimeDetails(info: Partial<ScheduleTimeRequestModel>): void {
    this.scheduleTimeDetails.next(info);
  }
  clearGlobalFilters(): void {
    this.globalFilterFormValueSubject.next(null);
  }
  setSchedulerConfig(info: ScheduleFieldVisibilityConfig): void {
    this.scheduleErrorMessages.next(info);
  }
  setInfo(info: IProviderManagementInfo): void {
    this.structureInfoSubject.next(info);
  }
  private selectedAssessmentsData: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public selectedAssessmentsData$: Observable<boolean> =
    this.selectedAssessmentsData.asObservable();

  public getSelectedAssessmentsData(data: boolean): void {
    this.selectedAssessmentsData.next(data);
  }
  getInfo(): IProviderManagementInfo | null {
    return this.structureInfoSubject.getValue();
  }

  public getHolidays(startDate: string, endDate: string): Observable<HolidayResponse[]> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http
      .get<HolidayResponse[]>(`${this.config.apiUrl}/Provider/GetHolidaysList`, { params })
      .pipe(catchError(handleError));
  }

  public getProviderPanel(
    payload: ProviderPanelRequest,
    statusID: number
  ): Observable<ProviderPanelResponse[]> {
    const endpoint: string =
      statusID === RequestType.Mandate
        ? 'ProviderManagement/GetProviderPanel'
        : 'EvaluatorAssignment/GetEvaluatorPanel';
    return this.http
      .post<ProviderPanelResponse[]>(
        `${this.config.apiUrl}/${endpoint}`,
        payload
      )
      .pipe(catchError(handleError));
  }

  public getDashboardRecords(
    request: DashoboardPMRequest
  ): Observable<DashboardPMResponse[] | evaluatorDashboardResponse[]> {
    const endpoint: string =
      request.requestType === RequestType.Mandate
        ? 'ProviderManagement/GetDashboardRecords'
        : 'EvaluatorAssignment/GetEvaluatorDashboard';
    return this.http
      .post<DashboardPMResponse[]>(`${this.config.apiUrl}/${endpoint}`, request)
      .pipe(catchError(handleError));
  }
  public getExportExcelMandates(
    mandateIds: string[]
  ): Observable<DashboardPMResponse[]> {
    const endpoint: string =
         'ProviderManagement/GetExportExcelMandates'
    return this.http
      .post<DashboardPMResponse[]>(
        `${this.config.apiUrl}/${endpoint}`,
        mandateIds
      )
      .pipe(catchError(handleError));
  }
  public setRecombineMandateRecords(
    request: RecombinePayload
  ): Observable<DashboardPMResponse[]> {
    const endpoint: string =
      'AgencySuperVisorDashboard/ReCombinedMandates';
    return this.http
      .post<DashboardPMResponse[]>(`${this.config.apiUrl}/${endpoint}`, request)
      .pipe(catchError(handleError));
  }

  public submitAssignProvider(
    request: AssignToProviderModel
  ): Observable<AssignProviderResponse> {
    return this.http
      .post<AssignProviderResponse>(
        `${this.config.apiUrl}/ProviderManagement/AssignProviderToMandate`,
        request
      )
      .pipe(catchError(handleError));
  }

  public retroActivelyAssignProvider(
    request: AssignToProviderModel
  ): Observable<AssignProviderResponse> {
    return this.http
      .post<AssignProviderResponse>(
        `${this.config.apiUrl}/ProviderManagement/RetroActivelyAssignToProvider`,
        request
      )
      .pipe(catchError(handleError));
  }
  public submitAssignEvaluator(
    request: AssignmentRequest
  ): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/RFARequest/AssignNYCPSEvaluators`,
        request
      )
      .pipe(catchError(handleError));
  }
  public getStudentProviderSchedules(
    request: StudentScheduleRequest
  ): Observable<StudentScheduleResponse[]> {
    return this.http
      .post<StudentScheduleResponse[]>(
        `${this.config.apiUrl}/Provider/GetStudentProviderSchedules`,
        request
      )
      .pipe(catchError(handleError));
  }
  public getStudentEvaluatorSchedules(
    request: StudentScheduleRequest
  ): Observable<StudentScheduleResponse[]> {
    return this.http
      .post<StudentScheduleResponse[]>(
        `${this.config.apiUrl}/Evaluations/GetStudentEvaluatorSchedules`,
        request
      )
      .pipe(catchError(handleError));
  }

  public submitReAssignEvaluator(
    request: ReAssignmentRequest
  ): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/RFARequest/ReAssignEvaluator`,
        request
      )
      .pipe(catchError(handleError));
  }
  public submitRAC(request: RacRequest): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/RequestedContractAssistance/SaveRCA`,
        request
      )
      .pipe(catchError(handleError));
  }
  public saveUnbundle(request: UnbundleRequest): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/RequestedContractAssistance/UnBundle`,
        request
      )
      .pipe(catchError(handleError));
  }
  public getDWSMandates(
    mandateCollectionSk: string
  ): Observable<IReferenceData[]> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/RequestedContractAssistance/GetAllDWSMandates/${encodeURIComponent(mandateCollectionSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<IReferenceData[]>(url)
      .pipe(catchError(handleError));
  }

  public getProviderDetails(
    providerSk: string
  ): Observable<IReferenceData[]> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/Provider/GetProviderDetails?providerSk=${encodeURIComponent(providerSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<IReferenceData[]>(url)
      .pipe(catchError(handleError));
  }
  public getMeetingSchedules(
    providerSk: string,
    startDate: string,
    endDate: string
  ): Observable<ISchedulerResponse[]> {
    const params: HttpParams = new HttpParams()
      .set('providerSk', providerSk)
      .set('startDate', startDate)
      .set('endDate', endDate);
    return this.http
      .get<ISchedulerResponse[]>(
        `${this.config.apiUrl}/Provider/GetProviderSchedules`,
        {
          params,
        }
      )
      .pipe(catchError(handleError));
  }
  public getMeetingEvaluatorSchedules(
    providerSk: string,
    startDate: string,
    endDate: string
  ): Observable<ISchedulerResponse[]> {
    const params: HttpParams = new HttpParams()
      .set('providerSk', providerSk)
      .set('startDate', startDate)
      .set('endDate', endDate);
    return this.http
      .get<ISchedulerResponse[]>(
        `${this.config.apiUrl}/Evaluations/GetEvaluatorSchedules`,
        {
          params,
        }
      )
      .pipe(catchError(handleError));
  }
  public getScheduleEvents(
    providerSk: string,
    startDate: string,
    endDate: string
  ): Observable<ISchedulerResponse[]> {
    const params: HttpParams = new HttpParams()
      .set('providerSk', providerSk)
      .set('startDate', startDate)
      .set('endDate', endDate);
    return this.http
      .get<ISchedulerResponse[]>(
        `${this.config.apiUrl}/Provider/GetCalendarSchedules`,
        {
          params,
        }
      )
      .pipe(catchError(handleError));
  }
  public submitPAMeeting(
    request: ScheduleEventSaveModel
  ): Observable<ICancelMeetingResponse> {
    return this.http
      .post(`${this.config.apiUrl}/ProviderManagement/AddPAMeeting`, request)
      .pipe(catchError(handleError));
  }

  public submitEvaluationMeeting(
    request: MeetingRequest
  ): Observable<ICancelMeetingResponse> {
    return this.http
      .post(`${this.config.apiUrl}/Evaluations/AddEvaluationMeeting`, request)
      .pipe(catchError(handleError));
  }

  public GetProviderSessionAvailability(
    request: ProviderSessionAvailability
  ): Observable<ProviderAvailabilityResponseItem[]> {
    return this.http
      .post<ProviderAvailabilityResponseItem[]>(
        `${this.config.apiUrl}/Provider/GetProviderSessionAvailability`,
        request
      )
      .pipe(catchError(handleError));
  }
  public GetEvaluatorSessionAvailability(
    request: EvaluatorAvailabilityRequest
  ): Observable<{ availability: string }> {
    return this.http
      .post<{ availability: string }>(
        `${this.config.apiUrl}/Evaluations/CheckEvaluatorAvailability`,
        request
      )
      .pipe(catchError(handleError));
  }

  public updatePAMeeting(
    request: UpdateEventsModel
  ): Observable<ICancelMeetingResponse> {
    return this.http
      .put(
        `${this.config.apiUrl}/ProviderManagement/CancelPAMeetingSession`,
        request
      )
      .pipe(catchError(handleError));
  }
  public updateEvaluatorScheduleMeeting(
    request: MeetingRequest
  ): Observable<ICancelMeetingResponse> {
    return this.http
      .put(`${this.config.apiUrl}/Evaluations/CancelEvaluationMeeting`, request)
      .pipe(catchError(handleError));
  }

  public cancelEvaluatorMeeting(
    request: CancelEvaluatorModel
  ): Observable<ICancelMeetingResponse> {
    return this.http
      .put(`${this.config.apiUrl}/Evaluations/CancelEvaluationMeeting`, request)
      .pipe(catchError(handleError));
  }

  public getPAMeeting(meetingSk: string): Observable<IProviderMeetingDetails> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/ProviderManagement/GetPAMeetingDetails/${encodeURIComponent(meetingSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<IProviderMeetingDetails>(url)
      .pipe(catchError(handleError));
  }

  public getEvaluatorMeetingDetails(
    meetingSk: string
  ): Observable<IProviderMeetingDetails> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/Evaluations/GetEvaluatorMeetingDetails/${encodeURIComponent(meetingSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<IProviderMeetingDetails>(url)
      .pipe(catchError(handleError));
  }
  public getProviderAgency(providerSk: string): Observable<ProviderAgencyResponse> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/Provider/GetProviderAgency?providerSk=${encodeURIComponent(providerSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<ProviderAgencyResponse>(url)
      .pipe(catchError(handleError));
  }
  public getStudentMandateDetails(
    payload?: IMatchingDetailsPayload
  ): Observable<GetMatchingSchedulesResponse[]> {
    return this.http
      .post<GetMatchingSchedulesResponse[]>(
        `${this.config.apiUrl}/Provider/GetMandateScheduleTimeInfo`,
        payload
      )
      .pipe(catchError(handleError));
  }

  public getAgencyProvider(providerSk: string): Observable<IReferenceData[]> {
    const params: HttpParams = new HttpParams().set('providerSk', providerSk);
    return this.http
      .get<IReferenceData[]>(
        `${this.config.apiUrl}/Provider/GetAgencyByProvider`,
        {
          params,
        }
      )
      .pipe(catchError(handleError));
  }
  public getServiceTypes(providerSk: string): Observable<IReferenceData[]> {
    const params: HttpParams = new HttpParams().set('providerSk', providerSk);
    return this.http
      .get<IReferenceData[]>(
        `${this.config.apiUrl}/Provider/GetProviderServicetypes`,
        {
          params,
        }
      )
      .pipe(catchError(handleError));
  }

  public getAllLanguages(providerSk: string): Observable<IReferenceData[]> {
    const params: HttpParams = new HttpParams().set('providerSk', providerSk);
    return this.http
      .get<IReferenceData[]>(
        `${this.config.apiUrl}/Provider/GetProviderLanguages`,
        {
          params,
        }
      )
      .pipe(catchError(handleError));
  }

  public getAllIepMandates(
    request: MeetingRequestModel
  ): Observable<MeetingRecordList[]> {
    // const params: HttpParams = new HttpParams().set('providerSk', studentSk).set('meetingType', meetingType.toString());
    return this.http
      .post<MeetingRecordList[]>(
        `${this.config.apiUrl}/ProviderManagement/GetIEPMeetingAttendees`,
        request
      )
      .pipe(catchError(handleError));
  }

  public getAllEvaluationAttendess(
    dbn: string
  ): Observable<EvaluationAttendeeResponse[]> {
    // const params: HttpParams = new HttpParams().set('providerSk', studentSk).set('meetingType', meetingType.toString());
    return this.http
      .get<EvaluationAttendeeResponse[]>(
        `${this.config.apiUrl}/ProviderManagement/GetEvaluationMeetingAttendees?DBN=${encodeURIComponent(dbn)}`,

      )
      .pipe(catchError(handleError));
  }
  public getCompareMandates(
    payload?: ICompareMandatesPaylaod
  ): Observable<IMandatesCompareResponse> {
    return this.http
      .post<IMandatesCompareResponse>(
        `${this.config.apiUrl}/Provider/GetScheduleMandateCompareInfo`,
        payload
      )
      .pipe(catchError(handleError));
  }

  public setreturnSchool(isScool: boolean): void {
    this.returnSchoolSubject.next(isScool);
  }

  public closePopup(data: boolean): void {
    this.popupClose$.next(data);
  }

  public getRacRecords(): Observable<DashboardPMResponse[]> {
    return this.http
      .get<DashboardPMResponse[]>(
        `${this.config.apiUrl}/RequestedContractAssistance/GetRCA`
      )
      .pipe(catchError(handleError));
  }

  public getBundles(payload: GetBundleRequestModel): Observable<IBundle[]> {
    return this.http
      .post<IBundle[]>(
        `${this.config.apiUrl}/RequestedContractAssistance/GetBundlesRecords`, payload
      )
      .pipe(catchError(handleError));
  }
  public getFeeForService(): Observable<FeeForServiceResponse> {
    return this.http
      .get<FeeForServiceResponse>(
        `${this.config.apiUrl}/RequestedContractAssistance/GetFeeForService`
      )
      .pipe(catchError(handleError));
  }

  public getDefinedWeeklySchedule(
    payload: DashoboardPMRequest
  ): Observable<weeklyScheduleResponse> {
    return this.http
      .post<weeklyScheduleResponse>(
        `${this.config.apiUrl}/RequestedContractAssistance/GetDefinedWeeklySchedule`,
        payload
      )
      .pipe(catchError(handleError));
  }
  public getAgenciesGridData(payload: RelatedContractAgenciesRequest): Observable<contractAgenciesResponse[]> {
    return this.http
      .post<contractAgenciesResponse[]>(
        `${this.config.apiUrl}/ProviderManagement/GetRelatedContractAgencies`, payload
      )
      .pipe(catchError(handleError));
  }
  public submitSMLocatePrimaryAgencyData(request: BundleRequestModel | LocatePrimaryAgencyRequest): Observable<LocatePrimaryAgencyResponse> {
    return this.http
      .post<LocatePrimaryAgencyResponse>(
        `${this.config.apiUrl}/LocatePrimaryAgency/ServiceModelandLocatePrimaryAgency`,
        request
      )
      .pipe(catchError(handleError));
  }

  public submitSMOutreachData(request: LocatePrimaryAgencyRequest): Observable<LocatePrimaryAgencyResponse> {
    return this.http
      .post<LocatePrimaryAgencyResponse>(
        `${this.config.apiUrl}/LocatePrimaryAgency/ServiceModelandContinueOutreach`,
        request
      )
      .pipe(catchError(handleError));
  }

  public updateTransmitToAgency(
    request: { mandateCollectionSk: string }[]
  ): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/LocatePrimaryAgency/UpdateRequestToTransmitToAgency`,
        request
      )
      .pipe(catchError(handleError));
  }
  public saveFFSPrimaryAgency(request: LocatePrimaryAgencyRequest | unknown): Observable<any> {
    return this.http
      .post<any>(
        `${this.config.apiUrl}/LocatePrimaryAgency/FFSAssignPrimaryLocation`,
        request
      )
      .pipe(catchError(handleError));
  }
  public saveDWPrimaryAgency(request: LocatePrimaryAgencyRequest | unknown): Observable<any> {
    return this.http
      .post<any>(
        `${this.config.apiUrl}/LocatePrimaryAgency/DWSAssignPrimaryLocation`,
        request
      )
      .pipe(catchError(handleError));
  }
  public getStudentSchoolAddress(
    request: getStudentSchoolAddressModel
  ): Observable<StudentSchoolAddressResponse> {
    return this.http
      .post<StudentSchoolAddressResponse>(
        `${this.config.apiUrl}/Provider/GetStudentSchoolAddress`,
        request
      )
      .pipe(catchError(handleError));
  }
  public getProviderAgencyAddress(providerSk: string): Observable<string> {
    const params: HttpParams = new HttpParams().set('providerSk', providerSk);

    return this.http
      .get(`${this.config.apiUrl}/Provider/GetProviderAgencyAddress`, {
        params,
        responseType: 'text',
      })
      .pipe(catchError(handleError));
  }
  public initiateOBD(request: OBDSaveModel): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/OBD/initiateOBD`,
        request
      )
      .pipe(catchError(handleError));
  }
  public getOBDDetails(request: OBDDetailsRequest): Observable<OBDDetailsResponse> {
    return this.http
      .post<OBDDetailsResponse>(`${this.config.apiUrl}/OBD/GetOBDDetails`, request)
      .pipe(catchError(handleError));
  }
  public saveOBDAgencyResponse(request: any): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(`${this.config.apiUrl}/OBD/UpdateOBDAgencyResponse`, request).pipe(catchError(handleError));
  }
  public OBDAgencyResponse(
    request: SubmitOBDAgencyResponse
  ): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/OBD/OBDAgencyResponse`,
        request
      )
      .pipe(catchError(handleError));
  }

  public ObdReSubmit(
    request: ObdReSubmitModel
  ): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/OBD/ObdResubmit`,
        request
      )
      .pipe(catchError(handleError));
  }

  public addPackage(payload: RSAPackageDto): Observable<AddPackageResponse> {
    return this.http.post<AddPackageResponse>(
      `${this.config.apiUrl}/RSAPackage/AddRSAPackage`,
      payload
    );
  }

  public addPreviewPackage(payload: RSAPackageDto): Observable<any> {

    return this.http
      .post<string>(
        `${this.config.apiUrl}/DocumentGen/PreviewPMIssuePackages`,
        payload
      )
      .pipe(catchError(handleError));
  }

  public getRsaPackage(body: {
    rsaPackageSk: string;
    selectedMandates: { mandateSk: string; mandateUniqueSK: string | null }[];
  }): Observable<RsaPackageResponse> {
    const url: string = `${this.config.apiUrl}/RSAPackage/GetRSAPackage`;
    return this.http.post<RsaPackageResponse>(url, body);
  }

  public updateRsaStatus(payload: RsaStatusUpdatePayload[]): Observable<void> {
    const url: string = `${this.config.apiUrl}/RSAPackage/UpdateRSAStatus`;
    return this.http.post<void>(url, payload);
  }

  searchEvaluator(
    payload: SearchEvaluatorRequest
  ): Observable<EvaluatorProvider[]> {
    return this.http
      .post<SearchEvaluatorResponse>(
        `${this.config.apiUrl}/AssignmentAuthorization/SearchEvaluator`,
        payload
      )
      .pipe(map((res: SearchEvaluatorResponse) => res.result ?? []));
  }

  public singleAwardToAgency(
    request: singleAwardToAgencySaveModel
  ): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(
        `${this.config.apiUrl}/OBD/SingleAwardToAgency`,
        request
      )
      .pipe(catchError(handleError));
  }

  public submitSplitMandates(
    request: UpdateMandateScheduleRequest
  ): Observable<SplitMandatesResponse> {
    return this.http
      .post<SplitMandatesResponse>(
        `${this.config.apiUrl}/AgencySuperVisorDashboard/SplitMandates`,
        request
      )
      .pipe(catchError(handleError));
  }
  public rejectWithdrawlTx(request: RejectWithdrawalTx): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(`${this.config.apiUrl}/AgencySuperVisorDashboard/WithdrawlTC`, request)
      .pipe(catchError(handleError));
  }
  public rejectCase(request: RejectWithdrawalTx): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(`${this.config.apiUrl}/AgencySuperVisorDashboard/RejectCase`, request)
      .pipe(catchError(handleError));
  }
  public retroActions(request: retroActionsModel[], inputType: OnBehalfActionType): Observable<ApiResponse<boolean>> {
    const endpoint: string = inputType === OnBehalfActionType.RetroFirstAttend ? 'EditFirstAttendDate' : 'AddNeverServedReason'
    return this.http
      .post<ApiResponse<boolean>>(`${this.config.apiUrl}/ProviderManagement/${endpoint}`, request)
      .pipe(catchError(handleError));
  }

  public awardToSystemRecommend(
    request: singleAwardToAgencySaveModel
  ): Observable<ApiResponse<SystemRecommendedAgency>> {
    return this.http
      .post<ApiResponse<SystemRecommendedAgency>>(
        `${this.config.apiUrl}/OBD/AwardToSystemRecommend`,
        request
      )
      .pipe(catchError(handleError));
  }


  public getProviders(
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.config.apiUrl}/ProviderManagement/GetAgencyProvidersForFilters`
      )
      .pipe(catchError(handleError));
  }

  public getStudents(
  ): Observable<ApiResponse<IReferenceData[]>> {
    return this.http
      .get<ApiResponse<IReferenceData[]>>(
        `${this.config.apiUrl}/ProviderManagement/GetStudentsForFilters`
      )
      .pipe(catchError(handleError));
  }
  private userDetailsData: BehaviorSubject<User> = new BehaviorSubject<User>(
    null
  );
  public userDetailsData$: Observable<User> =
    this.userDetailsData.asObservable();

  public getUserDetailsData(data: User): void {
    this.userDetailsData.next(data);
  }

  public getDocumentsRsaPackage(mandateSks: string[], isReview: boolean): Observable<string[]> {
    let params = new HttpParams();
    if (isReview !== undefined) {
      params = params.set('isReview', isReview);
    }
    return this.http
      .post<string[]>(
        `${this.config.apiUrl}/Document/PrintMandatePackageDocuments`, mandateSks,
        { params: params })
      .pipe(catchError(handleError));

    // const url: string = `${this.config.apiUrl}/Document/PrintMandatePackageDocuments`;
    // return this.http.post<string[]>(url, mandateSks);
  }

  public getEvaluatorDashboardDetails(evaluationSk: string): Observable<evaluatorDashboardResponse> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/EvaluatorAssignment/GetEvaluatorDashboardDetails/${encodeURIComponent(evaluationSk)}`,
      this.config.apiUrl
    );
    return this.http.post<evaluatorDashboardResponse>(url, null);
  }

  public getMandateSummaryDetails(mandateSk: string): Observable<DashboardPMResponse> {
    const url = `${this.config.apiUrl}/ProviderManagement/GetMandateSummaryRecords`;
    return this.http.post<DashboardPMResponse>(url, null, {
      params: {
        MandateSK: mandateSk
      }
    });
  }
  public getMandateAssociatedProvider(payload: any): Observable<any> {
    return this.http.post(
      `${this.config.apiUrl}/ProviderManagement/GetMandateAssociatedProvider`,
      payload
    );
  }

  public requestLocationProvider(payloads: { mandateSK: string; mandateSplitSK: string | null; status: number }[]): Observable<any> {
    const url = `${this.config.apiUrl}/ProviderManagement/RequestToLocationProvider`;
    return this.http.post<any>(url, payloads);
  }

}
